import { EnumModulo } from "../../../enums/enum-modulo";

export class ModuloModel {
    constructor(
        public modulo: EnumModulo = 1,
    ) { }
}